<template>
  <v-container class="pa-0 ma-0 d-flex flex-column">
    <!--drag and drop -->
    <v-container class="pa-0 ma-0 d-flex gap-6">
      <!-- right section + -->
      <v-container
        class="pa-4 ma-0"
        style="border: 1px solid #e6e6e6; border-radius: 4px; width: 334px"
      >
        <!-- header -->
        <v-container class="pa-0 ma-0 d-flex align-center gap-2">
          <!-- name header -->
          <v-card-text class="pa-0 ma-0 text-body-2" style="text-align: center">
            {{ $t("Groups") }}
          </v-card-text>

          <!-- search box -->
          <v-text-field
            v-model="search"
            :label="$t('Search in Groups')"
            height="38"
            outlined
            class="rtl-text ma-0 pa-0"
            hide-details="auto"
            clearable
          />
          <!-- select all -->
          <v-card-text class="pa-0 ma-0"></v-card-text>
          <v-btn
            :disabled="localdisplayedGroups.length == groups.length"
            @click="addAllItems()"
            class="pa-0 ma-0 mx-2"
            icon
            color="primary"
          >
            <v-card-text class="pa-0 ma-0 text-body-2">{{ $t("all") }}</v-card-text>
            <v-icon small class="pa-0 ma-0">mdi-plus</v-icon>
          </v-btn>
        </v-container>

        <!-- divider -->
        <v-container
          class="pa-0 my-3 ma-0"
          style="border-bottom: 1px solid #e3e3e3"
        ></v-container>

        <!-- list of title group produbcts -->
        <div
          style="
            height: 278px;
            overflow-y: auto;
            padding-right: 4px;
            scrollbar-width: none;
            -ms-overflow-style: none;
            overflow-x: hidden;
          "
        >
          <v-container
            v-for="(item, index) in filteredGroups"
            :key="item.id"
            :class="{
              'disabled-item': localdisplayedGroups.some((i) => i.id === item.id),
            }"
            class="pa-0 ma-0 mb-2"
            style="
              border: 1px solid #e3e3e3;
              border-radius: 4px;
              height: 42px;
              display: flex;
              align-items: center;
              padding: 0 16px;
              position: relative;
            "
          >
            <!-- image -->
            <img
              src="@/assets/shopping/placeHolderImage.png"
              alt="img"
              class="pa-1 mx-2"
              style="
                background: #eaeaea;
                height: 38px;
                width: 38px;
                min-width: 38px;
                border-radius: 4px;
              "
              loading="lazy"
            />
            <!-- products title -->
            <v-card-text
              class="pa-0 ma-0 text-body-2"
              style="margin-right: auto; margin-left: 12px"
            >
              {{ item.name }}
            </v-card-text>

            <!-- pluse btn -->
            <v-btn
              @click="addItem(item)"
              icon
              color="primary"
              style="margin-right: auto; margin-left: 0"
            >
              <v-icon class="ml-4">mdi-plus</v-icon>
            </v-btn>
          </v-container>
        </div>
      </v-container>

      <!-- left section X -->
      <v-container
        class="pa-4 ma-0"
        style="border: 1px solid #e6e6e6; border-radius: 4px; width: 639px"
      >
        <!-- header -->
        <v-container class="pa-0 ma-0 d-flex align-center gap-2">
          <!-- name header -->
          <v-card-text class="pa-0 ma-0 text-body-2" style="text-align: center">
            {{ $t("Display Groups in Menu") }}
          </v-card-text>

          <!-- search box -->
          <v-text-field
            v-model="searchDisplay"
            :label="$t('Search in Groups')"
            height="38"
            outlined
            class="rtl-text ma-0 pa-0"
            hide-details="auto"
            clearable
          />

          <!-- close all -->
          <v-card-text class="pa-0 ma-0 text-body-2">{{ $t("all") }}</v-card-text>
          <v-btn @click="removeAll" class="pa-0 ma-0" icon color="#F11E53">
            <v-icon small class="pa-0 ma-0">mdi-close</v-icon>
          </v-btn>
        </v-container>

        <!-- divider -->
        <v-container
          class="pa-0 my-3 ma-0"
          style="border-bottom: 1px solid #e3e3e3"
        ></v-container>

        <!-- list of title group produbcts -->
        <div
          style="
            height: 278px;
            overflow-y: auto;
            padding-right: 4px;
            scrollbar-width: none;
            -ms-overflow-style: none;
            overflow-x: hidden;
          "
        >
          <draggable
            v-model="localdisplayedGroups"
            handle=".drag-handle"
            :options="{
              animation: 200,
              direction: 'vertical',
              scrollSensitivity: 80,
            }"
          >
            <template v-for="(item, index) in filteredDisplayedGroups">
              <v-container
                :key="item.id"
                class="pa-0 ma-0 mb-2 drag-handle"
                style="
                  border: 1px solid #e3e3e3;
                  border-radius: 4px;
                  height: 42px;
                  display: flex;
                  align-items: center;
                  padding: 0 16px;
                  cursor: move;
                "
              >
                <v-container
                  class="pa-0 ma-0 d-flex align-center gap-2"
                  style="
                    width: 35px;
                    min-width: 45px;
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                  "
                >
                  <!-- index -->
                  <v-card-text
                    class="pa-0 pr-2 ma-0 text-body-2"
                    style="margin-left: 4px"
                  >
                    {{ index + 1 }}
                  </v-card-text>

                  <!-- equal icon -->
                  <v-icon small color="gray">mdi-equal</v-icon>
                </v-container>
                <img
                  src="@/assets/shopping/placeHolderImage.png"
                  alt="img"
                  class="pa-1 mx-2"
                  style="
                    background: #eaeaea;
                    height: 38px;
                    width: 38px;
                    min-width: 38px;
                    border-radius: 4px;
                  "
                  loading="lazy"
                />

                <v-card-text
                  class="pa-0 ma-0 text-body-2"
                  style="margin-right: auto; margin-left: 12px"
                >
                  {{ item.name }}
                </v-card-text>

                <v-btn
                  icon
                  color="#F11E53"
                  style="margin-right: auto; margin-left: 0"
                  @click="removeItem(index)"
                >
                  <v-icon class="ml-4">mdi-close</v-icon>
                </v-btn>
              </v-container>
            </template>
          </draggable>
        </div>
      </v-container>
    </v-container>
  </v-container>
</template>

<script>
import draggable from "vuedraggable";
import General from "@/Mixins/general";

export default {
  name: "GroupSelector",
  components: { draggable },
  mixins: [General],
  props: {
    displayedGroups: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    activeTab: "groups",
    search: "",
    searchDisplay: "",
    groups: [],
    tab: 0,
    selectedOption: "active",
    selectedSellOption: "sell",
    selectedOnlineOption: "active",
    selectedOnsiteOption: "active",
    localdisplayedGroups: [],
  }),
  mounted() {
    this.getproductCategory();
    this.localdisplayedGroups = [...this.displayedGroups];
  },
  watch: {
    displayedGroups: {
      deep: true,
      handler(newValue) {
        this.localdisplayedGroups = [...newValue];
        this.$emit("update:displayedGroups", newValue);
      },
    },
  },
  computed: {
    filteredGroups() {
      const keyword = this.search.trim();
      if (!keyword) return this.groups;
      return this.groups.filter((item) => item.name.includes(keyword));
    },
    filteredDisplayedGroups() {
      const keyword = this.searchDisplay.trim();
      if (!keyword) return this.localdisplayedGroups;
      return this.localdisplayedGroups.filter((item) => item.name.includes(keyword));
    },
  },
  methods: {
    removeItem(index) {
      this.localdisplayedGroups.splice(index, 1);
      this.$emit("update:displayedGroups", [...this.localdisplayedGroups]);
    },
    removeAll() {
      this.localdisplayedGroups = [];
      this.$emit("update:displayedGroups", [...this.localdisplayedGroups]);
    },
    addItem(item) {
      const hasItem = this.localdisplayedGroups.some((i) => i.id === item.id);
      if (hasItem) {
      } else {
        this.localdisplayedGroups.push({ ...item });
        this.$emit("update:displayedGroups", [...this.localdisplayedGroups]);
      }
    },
    addAllItems() {
      this.localdisplayedGroups = [...this.groups];
      this.$emit("update:displayedGroups", [...this.localdisplayedGroups]);
    },
    getproductCategory() {
      var app = this;
      app.loading = true;
      this.$axios
        .get(this.$apipoint + "v1/productcategory", {
          params: {
            type: "group",
            page: 1,
            itemPerPage: 1000,
          },
        })
        .then((response) => {
          app.loading = false;
          this.groups = response.data.data || [];
        })
        .catch((err) => {
          app.serverErrorHandeler(err);
          app.loading = false;
        })
        .finally(() => {
          app.loading = false;
        });
    },
  },
};
</script>

<style scoped>
::v-deep .v-label {
  top: 10px !important;
}
::v-deep .v-label.v-label--active {
  top: 18px !important;
}
::v-deep.v-btn--icon.v-size--default {
  width: 20px;
  height: 20px;
}
.v-card__text {
  width: auto;
}
.container {
  width: auto;
}
.disabled-item {
  opacity: 0.5;
  pointer-events: none;
}
</style>
